import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SecurityService } from 'app/shared/services/security.service';
import { AppConfig } from 'app/app.config';
import { NgxSpinnerService } from 'ngx-spinner';
import { SnotifyService } from 'ng-snotify';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IdentityService } from '../identity.service';
import { Router } from '@angular/router';
import { IDtoUser } from 'app/shared/models/security/dto-user.model';
@Component({
  selector: 'app-account-activation',
  templateUrl: 'account-activation.template.html'
})
export class AccountActivationComponent implements OnInit {
  /**Validadores */
  private validator = ValidatorService;
  private fsaFlags = [false];
  private errorMessages: any;
  /**Formulario */
  private frmActivation: FormGroup;
  constructor(private formBuilder: FormBuilder
    , private serviceSecurity: SecurityService
    , private identityService: IdentityService
    , private configGeneral: AppConfig
    , public snotifyService: SnotifyService
    , private router: Router
    , private spinner: NgxSpinnerService) {
    this.frmActivation = formBuilder.group({
      email: [null, [Validators.required, Validators.email]],
      code: [null, [Validators.required, Validators.maxLength(8), Validators.minLength(8)]],
      password: [null, [Validators.required, ValidatorService.formatPasswordValidator]],
      passwordConfirm: [null, Validators.required]
    },
      {
        validator: [ValidatorService.matchPassword('password', 'passwordConfirm')]
      });
  }

  ngOnInit() {

  }

  private onSubmit() {
    if (this.frmActivation.valid) {
      this.activateAccount();
    } else {
      // validate all form fields
    }
  }

  private activateAccount(): void {
    this.spinner.show();
    let user = {} as IDtoUser;
    user.email = this.frmActivation.value.email;
    user.username = this.frmActivation.value.email;
    user.password = this.frmActivation.value.password;
    user.code = this.frmActivation.value.code;
    this.identityService.accountActivation(user)
      .subscribe(
        (x) => {
          if (this.configGeneral.notificationSuccessError(x)) {
            this.router.navigate(['login']);
          }
          this.spinner.hide()
        },
        (errMessage) => this.errorMessages = errMessage.messages);
  }
}
